import React from 'react'

function SelectContainer({
  label,
  error,
  options,
  onSelectChange,
  formKey,
  info,
  value,
}) {
  return (
    <wb-select-control>
      <wb-select aria-labelledby="IdOfError">
        <label>{label}</label>
        <select
          onChange={(event) => {
            event.persist()
            onSelectChange({ event, formKey })
          }}
          defaultValue={value}
        >
          <option value="">Please select</option>
          {options.map((o) => (
            <option key={o.key} value={o.key}>
              {o.label}
            </option>
          ))}
        </select>
      </wb-select>
      <div>
        {info && info.length && (
          <wb-control-hint className="wb-padding-start-xs">
            {info}
          </wb-control-hint>
        )}
      </div>
      <div>
        {error && <wb-control-error id="IdOfError">{error}</wb-control-error>}
      </div>
    </wb-select-control>
  )
}

export default SelectContainer
